// src/store.js
import { createStore } from 'vuex';
import apiClient from './apiClient';
import router from './router';

export default createStore({
  state: {
    user: null,
    loggedIn: false,
    accessToken: null,
    userCredits: 0,
    userCreditsMin: 0,
    planName: '',
    planId: null,
    creditsMessage: '',
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.loggedIn = !!user;
    },
    SET_TOKEN(state, token) {
      state.accessToken = token;
    },
    LOGOUT(state) {
      state.user = null;
      state.loggedIn = false;
      state.accessToken = null;
      state.userCredits = 0;
      state.userCreditsMin = 0;
      state.planName = '';
      state.planId = null;
      state.creditsMessage = '';
    },
    SET_USER_CREDITS(state, creditsData) {
      state.userCredits = creditsData.user_credits;
      state.userCreditsMin = creditsData.user_credits_min;
      state.planId = creditsData.plan_id;
      state.planName = creditsData.plan_name;
      state.creditsMessage = creditsData.message;
    },
  },
  actions: {
    async login({ commit }, credentials) {
      try {
              localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      commit('LOGOUT');
        const response = await apiClient.post('/login/', credentials);
        const token = response.data.token;
        const user = {
          username: response.data.username,
          email: response.data.email,
          first_name: response.data.first_name,
          last_name: response.data.last_name,
          id: response.data.id,
        };
        // Store token and user info in local storage
        localStorage.setItem('accessToken', token);
        localStorage.setItem('user', JSON.stringify(user));
        
        console.log(localStorage.getItem('accessToken'));
        console.log(JSON.parse(localStorage.getItem('user')));
        commit('SET_TOKEN', token);
        commit('SET_USER', user);
      } catch (error) {
        console.error('Login failed:', error);
        throw error;
      }
    },
    async logout({ commit }) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      commit('LOGOUT');
        const response = await apiClient.get('/logout/');
      router.push('/login'); // Redirect to login page
    },
    loadSession({ commit }) {
      const token = localStorage.getItem('accessToken');
      const user = JSON.parse(localStorage.getItem('user'));
      if (token && user) {
        commit('SET_TOKEN', token);
        commit('SET_USER', user);
      }
    },
    async getUserCredits({ commit }) {
      try {
        const response = await apiClient.get('/user-credits/');
        const creditsData = response.data;
        commit('SET_USER_CREDITS', creditsData);
      } catch (error) {
        // Only force a logout on a genuine auth failure (expired / invalid
        // token). A transient or network error must NOT nuke the session —
        // that was logging users out when they clicked "buy booster" on the
        // subscription page (guardCheckout re-fetches credits on click).
        const status = error && error.response && error.response.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('user');
          commit('LOGOUT');
          try { await apiClient.get('/logout/'); } catch (e) { /* ignore */ }
          router.push('/login');
        } else {
          // keep the user signed in; just log it
          console.warn('getUserCredits failed (staying signed in):', status || error);
        }
      }
    },
    // Include other actions as needed
  },
  getters: {
    isLoggedIn: (state) => state.loggedIn,
    accessToken: (state) => state.accessToken,
    userInfo: (state) => state.user,
    userCredits: (state) => state.userCredits,
    userCreditsMin: (state) => state.userCreditsMin,
    planName: (state) => state.planName,
    planId: (state) => state.planId,
    creditsMessage: (state) => state.creditsMessage,
  },
});
